export class changePassword {
  aMdp?: string;
  nMdp?: string;
  cNMdp?: string;


  constructor(aMdp?: string, nMdp?: string, cNMdp?: string) {
    this.aMdp = aMdp;
    this.nMdp = nMdp;
    this.cNMdp = cNMdp;
  }
}
